
import "./dialog.scss";
import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { clearDialog, hideDialog } from "../../Actions/DialogActions";
import Button from "../../Common/Button";
import { type RootState } from "../../Reducers/DeveloperReducers";

const connector = connect((state: RootState) => state.dialog);

type PropsFromRedux = ConnectedProps<typeof connector>;

export type DialogButtonType = {
    type: "primary" | "secondary" | "normal";
    label: string;
    onClick: (event: React.MouseEvent) => void;
};

interface State {
    closed: boolean;
}

export class Dialog extends React.Component<PropsFromRedux, State> {
    public state: State = {
        closed: false,
    };

    public componentDidUpdate(prevProps: Readonly<PropsFromRedux>): void {
        if(prevProps.visible && !this.props.visible) {
            this.setState({
                closed: true,
            });
        } else if(!prevProps.visible && this.props.visible) {
            this.setState({
                closed: false,
            });
        }
    }

    public onBackdrop = (e: React.MouseEvent): void => {
        this.props.dispatch(hideDialog());

        e.stopPropagation();
    };

    public onAnimationEnd = (e: React.AnimationEvent): void => {
        if(e.animationName === "fade-out") {
            this.props.dispatch(clearDialog());
        }
    };

    public render(): React.ReactNode {
        const { visible, title, content, buttons, type, wide } = this.props;

        // Classes
        const classes = [];

        if(visible) {
            classes.push("open");
        } else if(this.state.closed) {
            classes.push("dialog-closed");
        }

        if(wide) {
            classes.push("wide");
        }

        const className = classes.join(" ");

        return (
            <>
                <div className={`dialog-backdrop ${className}`} onClick={this.onBackdrop} onAnimationEnd={this.onAnimationEnd} />
                <dialog open className={`${type} ${className} max-h-[80%] overflow-auto`}>
                    <h2 className="text-2xl">{title}</h2>
                    <div className="dialog-content">
                        {content}
                        {!!buttons.length && (
                            <div className="dialog-buttons">
                                {buttons.map(button => (
                                    <Button
                                        key={button.label}
                                        type="button"
                                        classes={[ button.type ]}
                                        onClick={button.onClick}
                                    >
                                        {button.label}
                                    </Button>
                                ))}
                            </div>
                        )}
                    </div>
                </dialog>
            </>
        );
    }
}

export default connector(Dialog);
